import React, { useContext, useState } from 'react'
import { DataContext } from '../../Context/Context'
import ProductCard0 from '../ProductCard0/ProductCard0';

function ProductList({withDetailsModal}) {

    const value = useContext(DataContext);
    const [products, setProducts] = value.products;
    function toggleSidebar() {
        setSidebarOpen(!sidebarOpen);
    }
    const [sidebarOpen, setSidebarOpen] = useState(false);
    return (

        <>
            {
                products.map(product => (
                    <div className="col-12 col-sm-6 col-md-4 col-xl-3 ">
                        <ProductCard0 key={product._id} product={product} withDetailsModal={withDetailsModal}  />
                    </div>
                ))
            }
        </>
    )
}

export default ProductList